import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { ValidationMessage } from "../../utils/constants/validationMessage";
import { integerInput, whiteSpaceCheck } from "../../helper/helper";
import { ErrorMessage } from "@hookform/error-message";
import PhoneInputField from "../shared/FormFields/PhoneInputField";
import { regex } from "../../utils/constants/regexVariables";
const OfficeInformation = ({
  register,
  errors,
  setOfficePhone,
  officePhone,
  setValue,
}) => {
  return (
    <div className="wrapper mw-100 position-relative mb-5 pb-2 px-md-4 px-3">
      <span className="wrapper-heading">Office Information</span>
      <Row className="mb-3 gx-sm-3 gx-2">
        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group controlId="formSurname">
            <Form.Label>
              Office Name{" "}
              <span className="text-danger">
                <span className="text-danger">*</span>
              </span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter office"
              name="officeName"
              {...register("officeName", {
                required: ValidationMessage.OFFICE_NAME_REQUIRED,
                validate: (value) => whiteSpaceCheck(value),
              })}
            />
            <ErrorMessage
              errors={errors}
              name="officeName"
              render={({ message }) => (
                <p className="error-message text-start py-2 px-1 text-danger">
                  {message}
                </p>
              )}
            />
          </Form.Group>
        </Col>

        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="">
            <Form.Label>
              Occupation Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Select
              name="relationWith"
              {...register(`officeOccupationName`, {
                required: ValidationMessage?.OCCUPATION_NAME_REQUIRED,
                validate: (value) => whiteSpaceCheck(value),
              })}
            >
              <option value="">Select Occupation type</option>
              <option value="private">Private</option>
              <option value="government">Government</option>
              <option value="business">Self-employed</option>
            </Form.Select>

            <ErrorMessage
              errors={errors}
              name={`officeOccupationName`}
              render={({ message }) => (
                <p className="error-message text-start py-2 px-1 text-danger">
                  {message}
                </p>
              )}
            />
          </Form.Group>
        </Col>

        {/*         <Col xl={3} md={4} sm={6} className="mb-3">

          <Form.Group controlId="formSurname">
            <Form.Label>Designation *</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter designation"
              name="officeDesignationName"
              {...register("officeDesignationName", {
                required: ValidationMessage.DESIGNATION_NAME_REQUIRED,
                validate: (value) => whiteSpaceCheck(value),
              })}
            />
            <ErrorMessage
              errors={errors}
              name="officeDesignationName"
              render={({ message }) => (
                <p className="error-message text-start py-2 px-1 text-danger">
                  {message}
                </p>
              )}
            />
          </Form.Group>
        </Col> */}

        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group controlId="formSurname">
            <Form.Label>
              Department <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter department"
              name="officeDepartmentName"
              {...register("officeDepartmentName", {
                required: ValidationMessage.DEPARTMENT_NAME_REQUIRED,
                validate: (value) => whiteSpaceCheck(value),
              })}
            />
            <ErrorMessage
              errors={errors}
              name="officeDepartmentName"
              render={({ message }) => (
                <p className="error-message text-start py-2 px-1 text-danger">
                  {message}
                </p>
              )}
            />
          </Form.Group>
        </Col>

        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group controlId="formSurname">
            <Form.Label>
              Office address line 1<span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter line 1"
              name="officeAddressLineO"
              {...register("officeAddressLineO", {
                required: ValidationMessage.ADDRESS_LINE_One,
                validate: (value) => whiteSpaceCheck(value),
              })}
            />
            <ErrorMessage
              errors={errors}
              name="officeAddressLineO"
              render={({ message }) => (
                <p className="error-message text-start py-2 px-1 text-danger">
                  {message}
                </p>
              )}
            />
          </Form.Group>
        </Col>

        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="">
            <Form.Label>Office address line 2</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter line 2"
              name="officeAddressLineOne"
              {...register("officeAddressLineOne", {
                required: false,
              })}
            />
          </Form.Group>
        </Col>
        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formEmail">
            <Form.Label>
              Office mobile no <span className="text-danger">*</span>
            </Form.Label>
            <PhoneInputField
              register={register}
              setValue={setValue}
              errors={errors}
              name="officePhone"
              validationMessage={ValidationMessage}
              regex={regex}
              countryCode="+91"
              initialPhone=""
              setPhone={setOfficePhone}
              phone={officePhone}
              className={""}
            />
            <ErrorMessage
              errors={errors}
              name="officePhone"
              render={({ message }) => (
                <p className="error-message text-start py-2 px-1 text-danger">
                  {message}
                </p>
              )}
            />
          </Form.Group>
        </Col>

        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formEmail">
            <Form.Label>Tel number(s):</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter line 1"
              name="officeTelNumber"
              {...register("officeTelNumber", {
                required: false,
              })}
              onKeyPress={(e) => integerInput(e)}
            />
          </Form.Group>
        </Col>

        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formEmail">
            <Form.Label>Website:</Form.Label>
            <Form.Control
              type="text"
              placeholder="Website link"
              name="officeWebsiteLink"
              {...register("officeWebsiteLink", {
                // required: ValidationMessage.WEBSITE_LINK_REQUIRED,
                required: false,
                validate: (value) => whiteSpaceCheck(value),
              })}
            />
            <ErrorMessage
              errors={errors}
              name="officeWebsiteLink"
              render={({ message }) => (
                <p className="error-message text-start py-2 px-1 text-danger">
                  {message}
                </p>
              )}
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default OfficeInformation;
